// ---------------------------------------------------------------------------
// Everything on the site is editable from this one file.
// Swap the image URLs, the video, the music track and the words below.
// ---------------------------------------------------------------------------

export const CONTENT = {
  name: "Annie",

  gate: {
    eyebrow: "A little something, made only for you",
    title: "For Annie",
    cta: "Tap to open",
  },

  hero: {
    // Each string is revealed line-by-line on load.
    lines: ["Happy", "Birthday", "Annie"],
    script: "the whole world feels warmer today",
    sub: "Today the calendar simply catches up with what my heart already knew — that a day this bright deserves a day of its own.",
  },

  marquee: "Happy Birthday Annie",

  gallery: {
    heading: "Moments",
    note: "Every one of these is you.",
    images: [
      {
        url: "/photos/annie-1.jpeg",
        caption: "elegance",
        pos: "center 15%",
      },
      {
        url: "/photos/annie-2.jpeg",
        caption: "golden hour",
        pos: "center 46%",
      },
      {
        url: "/photos/annie-3.jpeg",
        caption: "timeless",
        pos: "center 20%",
      },
      {
        url: "/photos/annie-4.jpeg",
        caption: "that smile",
        pos: "center 42%",
      },
    ],
  },

  timeline: {
    heading: "Chapters",
    items: [
      {
        no: "01",
        title: "A pharmacy, of all places",
        text: "I only walked in for some medication. I walked out having quietly handed over something far more important \u2014 my whole heart, to the girl I'd just met at the counter.",
        image: "/photos/annie-3.jpeg",
        pos: "center 20%",
      },
      {
        no: "02",
        title: "That smile of yours",
        text: "We barely get to meet \u2014 and still, the moment you smile, the second you laugh, I feel the whole thing click into place. There is nothing I love more than seeing you happy.",
        image: "/photos/annie-4.jpeg",
        pos: "center 42%",
      },
      {
        no: "03",
        title: "Today, and every one after",
        text: "So here's to you \u2014 to the year ahead, to the wishes you haven't made yet, and to being lucky enough to know someone like you.",
        image: "/photos/annie-1.jpeg",
        pos: "center 15%",
      },
      {
        no: "04",
        title: "And what comes next?",
        text: "If I get any say in how this story goes, I already know my answer. What happens after today? I'm quietly, hopefully wishing for a forever with you.",
        image: "/photos/annie-2.jpeg",
        pos: "center 46%",
      },
    ],
  },

  video: {
    heading: "Press play",
    note: "A little film of you.",
    clips: [{ src: "/combined.mp4", poster: "/posters/combined.jpg" }],
  },

  // The gate stays locked with a live countdown until Annie's birthday,
  // then unlocks automatically. Unlock time = 00:00 on this date in GMT/UTC (Accra).
  // Preview anytime before the birthday by adding ?preview=1 to the URL.
  birthday: {
    month: 8, // August
    day: 22,
    hourUTC: 0, // midnight GMT/UTC (Accra, Ghana)
    year: 2026, // pin so the site stays unlocked after Aug 22 this year
    label: "22 August",
  },

  // Featured song via official Spotify embed ("Rest of My Life" — Keenan Te).
  // To change the song, paste a new Spotify track embed URL below.
  // Self-hosted full song (same-origin) — plays for everyone, no login.
  music: {
    url: "/music.mp3",
    title: "Rest of My Life",
    artist: "Keenan Te",
  },

  finalMessage: {
    script: "one last thing",
    title: "Happy Birthday, Annie.",
    body: [
      "If today could be measured in the way I mean it, it would last far longer than twenty-four hours.",
      "Thank you for being exactly, wonderfully you. I hope this year is soft where you need it to be, loud where you want it to be, and kind all the way through.",
      "Make a wish. I already made mine.",
    ],
    signature: "— always, from someone who thinks the world of you",
  },
};
